"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _FavoriteBorder = _interopRequireDefault(require("@material-ui/icons/FavoriteBorder"));
var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));
var _style = require("./style");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Card = _ref => {
  let {
    classNameImage,
    classNameIconButton,
    children,
    childrenActions,
    iconImage,
    image,
    imageHoverText,
    list,
    listSize,
    onClick,
    onFavorite,
    size,
    showIconButton,
    iconSelected,
    hasFavorite,
    handleFavorite,
    handleUnfavorite,
    classCardContent,
    favorite
  } = _ref;
  const classes = (0, _style.useStyles)();
  const matches = (0, _core.useMediaQuery)('(max-width:769px)');
  const [hover, setHover] = (0, _react.useState)(false);
  const [isFavorite, setIsFavorite] = (0, _react.useState)(favorite);
  const handleIsFavorite = () => {
    setIsFavorite(!isFavorite);
    handleFavorite();
  };
  const handleIsUnfavorite = () => {
    setIsFavorite(!isFavorite);
    handleUnfavorite();
  };
  const classIconButton = size === 'lg' ? classes.iconButtonMedium : classes.iconButtonSmall;
  const iconButtonStyle = {
    width: listSize === 'lg' && 36 || listSize === 'sm' && 26,
    height: listSize === 'lg' && 36 || listSize === 'sm' && 20,
    fontSize: listSize === 'sm' && 20,
    position: listSize === 'lg' && 'absolute' || listSize === 'sm' && 'absolute',
    right: size !== 'lg' && 4,
    top: listSize === 'lg' && 12 || listSize === 'sm' && 6 || size !== 'lg' && 6,
    color: 'rgba(33, 37, 41, 1)',
    backgroundColor: iconSelected && iconSelected && '#CD444B',
    transition: iconSelected && iconSelected && 'none'
  };
  const muicardStyle = {
    width: list ? 'auto' : (0, _utils.checkSizeCard)(size),
    height: list && (0, _utils.checkSizeListHeight)(listSize),
    marginTop: size !== 'lg' && 16,
    marginRight: size !== 'lg' && 16,
    marginLeft: size !== 'lg' && 16,
    display: list && 'flex',
    alignItems: list && 'flex-end',
    position: list ? 'relative' : 'inherit'
  };
  const cardActionsStyle = {
    display: list && 'flex',
    flexDirection: list && 'column'
  };
  const cardMediaStyle = {
    maxWidth: !list && size !== 'lg' && '100%',
    width: list && listSize === 'sm' && 65 || list && listSize === 'lg' && 100,
    height: !list && size !== 'lg' && 'auto' || list && listSize === 'sm' && 90 || list && listSize === 'lg' && 140,
    marginTop: size !== 'lg' && 16 || list && listSize === 'sm' && 16,
    marginLeft: size !== 'lg' && 16,
    marginRight: size !== 'lg' && 16,
    marginBottom: size !== 'lg' && 16
  };
  const favButtonGalleryStyle = {
    left: !list && size === 'lg' && 24 || !list && size === 'md' && 16 || !list && size === 'sm' && 16 || !list && size === 'vsm' && 16,
    bottom: !list && size === 'lg' && 24 || !list && size === 'md' && 16 || !list && size === 'sm' && 16 || !list && size === 'vsm' && 0
  };
  const cardContentStyle = classCardContent || {
    display: list && 'flex',
    flexDirection: list && 'column',
    height: list && listSize === 'sm' && 135
  };
  const favButtonListStyle = {
    top: 24,
    right: 24,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderRadius: '50%',
    border: 'none'
  };
  const favButtonListStyleMobile = {
    bottom: 16,
    left: 16,
    borderRadius: '0 8px 0 6px'
  };
  if (hasFavorite) return /*#__PURE__*/_react.default.createElement(_core.Card, {
    style: muicardStyle,
    className: classes.card
  }, list && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    style: matches ? favButtonListStyleMobile : favButtonListStyle,
    onClick: isFavorite ? handleIsUnfavorite : handleIsFavorite,
    className: classes.mediaChildren,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? /*#__PURE__*/_react.default.createElement(_Favorite.default, {
    style: {
      color: '#212529'
    },
    fontSize: "24"
  }) : /*#__PURE__*/_react.default.createElement(_FavoriteBorder.default, {
    style: {
      color: '#616161'
    },
    fontSize: "24"
  })), /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: {
      padding: listSize === '' && 0
    },
    className: classes.cardActions
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    style: cardMediaStyle,
    className: `${classNameImage} ${list ? `${classes.mediaList} ${classes.imageDefault}` : `${classes.media} ${classes.imageDefault}`}`,
    src: image,
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick: onClick
  }), showIconButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    style: iconButtonStyle,
    className: `${classNameIconButton} ${classIconButton}`,
    "aria-label": "Menu do Livro"
  }, iconImage), !list && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    style: favButtonGalleryStyle,
    onClick: isFavorite ? handleIsUnfavorite : handleIsFavorite,
    className: classes.mediaChildren,
    "aria-label": isFavorite ? 'Desfavoritar Livro' : 'Favoritar Livro'
  }, isFavorite ? /*#__PURE__*/_react.default.createElement(_Favorite.default, {
    style: {
      color: '#212529'
    },
    fontSize: "24"
  }) : /*#__PURE__*/_react.default.createElement(_FavoriteBorder.default, {
    style: {
      color: '#616161'
    },
    fontSize: "24"
  })), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: list ? classes.titleList : classes.title
  }, imageHoverText))), children && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.cardContent,
    style: cardContentStyle
  }, children), childrenActions && /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: cardActionsStyle,
    className: classes.cardActionsButton
  }, /*#__PURE__*/_react.default.createElement("div", null, childrenActions)));
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    style: muicardStyle,
    className: classes.card
  }, /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: {
      padding: listSize === '' && 0
    },
    className: classes.cardActions
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
    component: "img",
    style: cardMediaStyle,
    className: `${classNameImage} ${list ? `${classes.mediaList} ${classes.imageDefault}` : `${classes.media} ${classes.imageDefault}`}`,
    src: image,
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false),
    onClick: onClick
  }), showIconButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onFavorite,
    style: iconButtonStyle,
    className: `${classNameIconButton} ${classIconButton}`,
    "aria-label": "Menu do Livro"
  }, iconImage), hover && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    className: list ? classes.titleList : classes.title
  }, imageHoverText))), children && /*#__PURE__*/_react.default.createElement(_core.CardContent, {
    className: classes.cardContent,
    style: cardContentStyle
  }, children), childrenActions && /*#__PURE__*/_react.default.createElement(_core.CardActions, {
    style: cardActionsStyle,
    className: classes.cardActionsButton
  }, /*#__PURE__*/_react.default.createElement("div", null, childrenActions)));
};
exports.Card = Card;
Card.propTypes = {
  /**
    Aplicar estilização na imagem do card
  */
  classNameImage: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  /**
    Aplicar estilização no ícone da média
  */
  classNameIconButton: _propTypes.default.shape({
    root: _propTypes.default.string.isRequired
  }),
  /**
   Conteúdo do componente Card
  */
  children: _propTypes.default.node,
  /**
    Ações para interagir com o card, exemplo: Button
  */
  childrenActions: _propTypes.default.node,
  /**
    Ícone para imagem
  */
  iconImage: _propTypes.default.node,
  /**
   Imagem a ser exibida de background
  */
  image: _propTypes.default.string.isRequired,
  /**
    Texto exibido quando usuário passa mouse sobre a media do card
  */
  imageHoverText: _propTypes.default.node,
  /**
    Se a propriedade for true card fica em formato de list
  */
  list: _propTypes.default.bool,
  /**
    Se a propriedade for true card fica em formato de list
  */
  favorite: _propTypes.default.bool,
  /**
    Altura do card no formato list
  */
  listSize: _propTypes.default.oneOf(['lg', 'sm']),
  /**
    Função acionada ao clicar na média do card
  */
  onClick: _propTypes.default.func,
  /**
    Função acionada ao clicar no ícone da média do card
  */
  onFavorite: _propTypes.default.func,
  /**
    Tamanho do card
  */
  size: _propTypes.default.oneOf(['lg', 'md', 'sm']),
  /**
   Se verdadeiro exibe o icone passado dentro de um componente IconButton
  */
  showIconButton: _propTypes.default.bool,
  /** Define se o ícone clicado é ícone de favorito para que seja trocado o Background color do botão que engloba o icone */
  iconSelected: _propTypes.default.bool,
  /**
   * Se TRUE, o componente recebe o favorite button usado -inicialmente- nas estante da BDS
   */
  hasFavorite: _propTypes.default.bool,
  /**
   * Funcao a ser executata ao favoritar o card com o hasFavorite true
   */
  handleFavorite: _propTypes.default.func,
  /**
   * Funcao a ser executada ao desfavoritar o card com o hasFavorite true
   */
  handleUnfavorite: _propTypes.default.func,
  /*
  Classe de estilo do card content
   */
  classCardContent: _propTypes.default.shape({
    root: _propTypes.default.string
  })
};
Card.defaultProps = {
  classNameImage: null,
  classNameIconButton: null,
  children: null,
  childrenActions: null,
  iconImage: null,
  iconSelected: null,
  imageHoverText: 'Content',
  list: false,
  listSize: null,
  onClick: null,
  onFavorite: null,
  size: 'lg',
  showIconButton: false,
  hasFavorite: false,
  favorite: false,
  handleFavorite: null,
  handleUnfavorite: null,
  classCardContent: {}
};